<template>
  <div>
    <div v-if="(page.network === 'linkedin' && activeLinkedinCredentials) || ( page.network === 'instagram' && activeInstagramStories) || (page.network === 'tiktok' && activeTiktokCredentials) || (page.network === 'twitter' && activeTwitterCredentials) || (page.network === 'facebook' && (page.isGroup && activeFacebookCredentials || (page.story_config && page.story_config.created)))" class="connection">
      <Tooltip text="Conciergerie" position="top">
        <img class="conciergerie" :class="[linkedinConnected]" src="../../../assets/img/bell_concierge.svg" @click="conciergeriePopup = !conciergeriePopup" /> 
        &nbsp;
      </Tooltip>
      <vs-popup :title="page.network === 'linkedin' && !linkedinCredentialsOverrideEnabled() ? $t('dash.bots.connection_linkedin_native') : $t(`dash.bots.connection_${page.network}`)" :active.sync="conciergeriePopup" class="overlay conciergerie-connection">
        <p class="subtitle">{{ page.network === 'linkedin' && !linkedinCredentialsOverrideEnabled() ? $t('dash.bots.connection_subtitle_linkedin_native') : $t(`dash.bots.connection_subtitle_${page.network}`) }}</p>
        <div v-if="linkedinConnected === 'locked'">
          <p class="connect-warning">{{$t('dash.story.account.locked')}} {{new Date(page.story_config.lock).toLocaleString()}}</p>
        </div>
        <div v-else-if="linkedinConnected === 'connected'">
          <p v-if="!noMatchId" class="connect-success">{{$t('dash.bots.connected_direct')}}</p>
          <div v-else>
            <p class="connect-warning">{{$t('dash.bots.connected_match')}}</p>
          </div>
          <p class="connect-warning" v-if="analysts && analysts.length">{{$t("dash.bots.analysts") + " " + analysts.join(", ")}}</p>
          <p class="connect-warning" v-if="usernamePageDiff">{{$t("dash.bots.username_diff_insta").replace("d'utilisateur", usernamePageDiff) + " " +page.name}}</p>
          <!-- <vs-button v-if="noMatchId" class="modify-btn-linkedin" @click="() => disconnectConciergerie(page.id)">{{$t('dash.posts.disclaimer-post.change-tab.prompt.btn-cancel')}}</vs-button> -->
          <!-- <vs-button v-if="noMatchId" class="disconnect-conciergerie" @click="() => conciergeriePopup=false">{{$t('dash.bots.username_diff_insta_btn1').replace("avec", "")}}</vs-button> -->
          <vs-button v-if="!connectionReturn" class="modify-btn-linkedin" @click="() => linkedinModify=true">Modifier</vs-button>
          <Tooltip v-if="!connectionReturn" :text="$t('dash.pages.disconnect_conciergerie')" position="right">
            <vs-button
              @click="disconnectConciergerie(page.id)" class="disconnect-conciergerie">
              <p>{{$t("dash.header.nav.logout")}}</p>
              <!-- <p>{{$t("dash.pages.disconnect_conciergerie")}}</p> -->
            </vs-button>
            <span>&nbsp;</span>
          </Tooltip>
          <vs-button v-else-if="!noMatchId" class="modify-btn-linkedin" @click="() => conciergeriePopup=false">OK</vs-button>
          <vs-button v-if="usernamePageDiff && !noMatchId"
              @click="disconnectConciergerie(page.id)" class="disconnect-conciergerie">
              <p>{{$t("dash.header.nav.logout")}}</p>
              <!-- <p>{{$t("dash.pages.disconnect_conciergerie")}}</p> -->
            </vs-button>
        </div>
        <div v-else-if="noMatchId">
          <p class="connect-warning">{{$t('dash.bots.connected_match')}}</p>
          <vs-button class="modify-btn-linkedin" @click="() => noMatchId=false">OK</vs-button>
        </div>
        <div v-else class="conciergerie-instruction">
          <h3 v-if="['linkedin', 'tiktok', 'facebook', 'twitter'].includes(page.network)" class="conciergerie-instruction-title">{{page.network === 'tiktok' ? $t('dash.bots.connection_method_tiktok') : page.network === 'facebook' ? $t('dash.bots.connection_method_facebook') : page.network === 'twitter' ? $t('dash.bots.connection_method_twitter') : linkedinCredentialsOverrideEnabled() ? $t('dash.bots.connection_method_1') : $t('dash.bots.connection_method_linkedin')}}</h3>
          <div v-if="['linkedin', 'tiktok', 'facebook', 'twitter'].includes(page.network)" class="conciergerie-instruction-method method-1">
            <vs-button v-if="!extension" @click="useExtension">{{$t(`dash.bots.connection_open_extension`)}}</vs-button>
            <p v-if="!extension">{{$t('dash.bots.extension_explication_1')}}</p>
            <p  v-if="!extension" v-html="$t(`dash.bots.extension_explication_2_${page.network}`)"></p>
            <p v-else v-html="$t(`dash.bots.extension_explication_3_${page.network}`)"></p>
          </div>
          <h3 v-if="page.network === 'linkedin' && linkedinCredentialsOverrideEnabled()" class="conciergerie-instruction-title">{{$t('dash.bots.connection_method_2')}}</h3>
          <div v-if="page.network === 'instagram' || (page.network === 'linkedin' && linkedinCredentialsOverrideEnabled())" class="conciergerie-instruction-method method-2">
            <vs-input :label="$t(`dash.bots.connection_email${page.network === 'instagram' ? '_username' : ''}`)" :placeholder="$t(`dash.bots.connection_email${page.network === 'instagram' ? '_username' : ''}`)" v-model="linkedinUsername" @keypress.enter.prevent="connectLinkedin" @submit.prevent="connectLinkedin"/>
            <vs-input :type="showPass ? 'text' : 'password'" :label="$t('dash.bots.connection_password')" :placeholder="$t('dash.bots.connection_password')" v-model="linkedinPassword" @submit.prevent="connectLinkedin" @keypress.enter.prevent="connectLinkedin"/>
            <vs-button class="btn-eye" type="fill"
              @click="showPass = !showPass"
              :icon="showPass ? 'visibility_off' : 'visibility'"
            ></vs-button>
          </div>
          <template v-if="page.network === 'instagram' || (page.network === 'linkedin' && linkedinCredentialsOverrideEnabled())">
            <!-- <p class="warning-two-auth" v-if="['linkedin', 'instagram'].includes(page.network)">{{ $t('dash.bots.warning_two_auth')}}</p>
            <p class="warning-two-auth" v-if="['instagram'].includes(page.network)">{{ $t('dash.bots.warning_two_auth_insta')}}</p> -->
            <p class="warning-two-auth" v-if="['linkedin'].includes(page.network)">{{ $t('dash.bots.warning_two_auth')}}</p>
            <!-- <p class="warning-two-auth" v-if="['instagram'].includes(page.network)">{{ $t('dash.bots.warning_no_two_auth')}}</p> -->
            <div class="username-conciergerie-diff" v-if="page.network === 'instagram' && instagramPagesUsernames.map(e => e.username).includes(linkedinUsername)">
              <p >{{$t("dash.bots.username_used_insta") + instagramPagesUsernames.find(e => e.username === linkedinUsername).name}}</p>
              <vs-button style="text-transform: none;" :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="() => linkedinUsername =''" color="primary" type="filled">{{$t("dash.button.cancel")}}</vs-button>
              ou
              <vs-button :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="connectLinkedin" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn1") + linkedinUsername}}</vs-button>
            </div>
            <div class="username-conciergerie-diff" v-else-if="page && page.id !== 'createPage' && page.network === 'instagram' && linkedinUsername && page.name.trim() !== linkedinUsername.trim()">
              <p >{{$t("dash.bots.username_diff_insta")}}</p>
              <vs-button :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="connectLinkedin" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn1") + linkedinUsername}}</vs-button>
              ou
              <vs-button style="text-transform: none;" :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="(e) => connectLinkedin(e, true)" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn2") + page.name}}</vs-button>
            </div>
            <vs-button v-else :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container" @click="connectLinkedin" color="primary" type="filled">{{ $t('dash.bots.connect_direct') }}</vs-button>
          </template>
        </div>
        <vs-popup title="Authentification à deux facteurs" :active.sync="twoFactorPopup" class="two-factor-authentification">
          <TwoFactorAuthenticationPopup :pageid="twoFactorPopup" :pages="pages" @closePopup="closePopup" v-on:getPagesEvent="getPagesEvent"/>
        </vs-popup>
        <component-loader :progress="90" :unlimitedProgress="true" v-if="showLoader" :activeClose="true" v-on:close="showLoader = false"></component-loader>
      
      </vs-popup>
    </div>
  </div>
</template>

<script>

import User from '../../mixins/User'
import Pages from '../../mixins/Pages'
import Bots from '../../mixins/Bots'
import Notif from '../../mixins/Notif'
import TwoFactorAuthenticationPopup from '../TwoFactorAuthenticationPopup.vue'
import componentLoader from './Loader.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
  name: 'component-conciergerie',
  
  mixins: [Bots, Pages, User, Notif],

  props: {
    page: Object,
  },

  components: {
    TwoFactorAuthenticationPopup,
    componentLoader,
    Tooltip
  },

  data() {
    return {
      showPass: false,
      linkedinModify: false,
      linkedinUsername: '',
      linkedinPassword: '',
      twoFactorPopup: false,
      conciergeriePopup: false,
      pages: [],
      extension: false,
      showLoader: false,
      connectionReturn: false,
      instagramPagesUsernames: [],
      usernamePageDiff: null,
      noMatchId: false,
      analysts: [],
    }
  },

  computed: {
    linkedinConnected() {
      if (this.page.story_config && this.page.story_config.created && this.page.story_config.lock && this.page.story_config.lock > Date.now() && (((this.page.network === 'instagram')))) {
        return 'locked';
      }
      if (this.linkedinModify) {
        return 'modify';
      }
      if (this.page.story_config && this.page.story_config.created) {
        return 'connected';
      } else if (this.page.story_config && ((this.page.network === 'linkedin' && this.page.story_config.challenge_informations) || (this.page.network === 'instagram' && this.page.story_config.two_factor))) {
        return 'challenge';
      } else {
        return 'none';
      }
    },
  },

  mounted() {
    this.checkLockDirectApi(this.page);
    this.extensionInstalled()
    // this.getInstagramPagesUsername()
    // console.log('mount')
  },

  watch: {
    conciergeriePopup: function(newVal) {
      if (newVal) {
        this.getInstagramPagesUsername()
      }
    }
  },

  methods: {

    isProd() {
      return process.env.VUE_APP_API_HOST === 'https://api.saas.mashup-web.com'
    },
    
    linkedinCredentialsOverrideEnabled() {
      return localStorage.getItem('mw_debug_linkedin_credentials') === 'true'
    },

    async getInstagramPagesUsername() {
      this.getPages().then(res => {
        let {pages} = res.body;
        this.instagramPagesUsernames = pages.filter(e => e.network === 'instagram' && e.id !== this.page.id).map(e => {return {username: e.instagram_username, name: e.name}});
      })
      
    },

    async extensionInstalled() {
      return new Promise((resolve, reject) => {
        let img = new Image();
        const extensionId = "lmojmckfefcipoompcaedhnbbkeceohm"
        img.src = "chrome-extension://" + extensionId + "/icons/icon_16.png";
        img.onload = () => {
          this.extension = true;
          resolve(true);
        };
        img.onerror = () => {
          this.extension = false;
          resolve(false);
        };
      });
    },

    useExtension() {
      if (typeof chrome !== 'undefined') {
        this.extensionInstalled().then(installed => {
          if (installed) {
            const targetUrl = this.page.network === 'tiktok' ? 'https://www.tiktok.com/' : this.page.network === 'facebook' ? 'https://www.facebook.com/' : this.page.network === 'twitter' ? 'https://x.com/' : 'https://linkedin.com/';
            window.open(targetUrl, '_blank').focus();
          } else {
            console.log('redirect to download link');
            window.open("https://chrome.google.com/webstore/detail/mashup-web/lmojmckfefcipoompcaedhnbbkeceohm", '_blank').focus();
          }
          this.conciergeriePopup = false
        })
      } else {
        this.$vs.notify({
          title: "Navigateur incompatible",
          text: this.$t("dash.bots.extension_chrome_only"),
          color:'warning',
          time: 10000
        })
      }
    },

    activeInstagramStories() {
      const accounts = [
        '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
        'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
        'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
        '251e3e67-2bc7-4634-b6e7-4be8ea1105aa', //auto-ies
        '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
        'd3035c77-8361-4e28-8239-66b672bfa72c', //honorsguests
        '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
        '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
        '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
        '90e789fa-7377-434c-b719-132aa8bcd1d2', //keepeo.fr
        'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
        '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
        '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
        '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
      ]

      const users = [
        '7a4c371e-86b7-4c7f-b217-83203e9e8e17' //Augagneur reworld
      ]

      const user = JSON.parse(localStorage.user)
      //return accounts.includes(user.account) || this.checkLock('instagram_story') || user.email.includes("@mashup-web.com")
      return this.checkLock('instagram_credentials') || accounts.includes(user.account) || users.includes(user.id) || user.email.includes("@mashup-web.com")
    },

    activeLinkedinCredentials() {
      const accounts = [
        '935a2b07-141c-432f-a54e-975125fdeefc', //david NWX
        '251e3e67-2bc7-4634-b6e7-4be8ea1105aa', //Auto-ies
        '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
        /*'63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
        'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
        'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard*/
        'eb8ae373-cb54-46d2-b456-1b60b568b62f', // groupebba-bma.com
        '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
        '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
        '90e789fa-7377-434c-b719-132aa8bcd1d2', //keepeo.fr
        'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
        '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
        '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
        '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
      ]

      const users = [
        '7a4c371e-86b7-4c7f-b217-83203e9e8e17' //Augagneur reworld
      ]

      const user = JSON.parse(localStorage.user)
      return this.checkLock('linkedin_credentials') || accounts.includes(user.account) || users.includes(user.id) || user.email.includes("@mashup-web.com")
    },

    activeTiktokCredentials() {
      const user = JSON.parse(localStorage.user)
      return this.checkLock('tiktok_credentials') || user.email.includes("@mashup-web.com")
    },

    activeTwitterCredentials() {
      const user = JSON.parse(localStorage.user)
      return this.checkLock('twitter_credentials') || user.email.includes("@mashup-web.com")
    },

    activeFacebookCredentials() {
      const user = JSON.parse(localStorage.user)
      return this.checkLock('facebook_credentials') || user.email.includes("@mashup-web.com")
    },

    async connectLinkedin(e, replaceUsername=false) {
      // console.log(this.linkedinUsername);
      // console.log(this.linkedinPassword);
      // console.log(this.page.id);
      if (replaceUsername) {
        this.linkedinUsername = this.page.name;
      }

      // Only drop the @ of "@username": an email login keeps its @ (Instagram accepts it)
      this.linkedinUsername = this.page.network === 'instagram' ? this.linkedinUsername.replace(/\s/g, '').replace(/^@/, '') : this.linkedinUsername.trim();
      this.linkedinPassword = this.linkedinPassword.trim();
      let body = {
        pageId: this.page.id,
        usernameAccount: this.linkedinUsername,
        passwordAccount: this.linkedinPassword,
      }
      this.$vs.loading();
      // this.showLoader = true;

      this.connectLinkedinDirect(body).then(async response =>  {
          // console.log(response);
          this.$vs.loading.close();
        // this.showLoader = false;
        if (response.ok && response.body && response.body.connected) {
          this.usernamePageDiff = (this.page && this.page.id !== 'createPage' && response.body.username !== this.page.name) ? response.body.username : null;
          await this.fetchPages();
          this.linkedinModify = false;
          this.connectionReturn = true;
          this.getPagesEvent()
          this.noMatchId = !response.body.match;
          if (response.body.analysts) {
            this.analysts = response.body.analysts;
          } else {
            this.analysts = [];
          }
          // this.submitAfterConnection(); 
        } else if (response.ok && response.body && response.body.twoAuth) {
          this.fetchPages();
          this.twoFactorPopup = this.page.id
        } else if (response.ok && response.body && response.body.challengeInstagram) {
          if (response.body.id) {
            this.page.id = response.body.id;
          }
          this.fetchPages();
          this.twoFactorPopup = this.page.id;
          // this.$vs.notify({
          // this.notify({
          //   title:'Erreur de connexion',
          //   text: this.$t('dash.bots.two_auth_failed'),
          //   color: 'primary',
          //   time: 10000,
          //   id: this.page.id
          // }, {
          //   component: "Conciergerie",
          //   action: "connectLinkedinDirect",
          //   params: {
          //     pageId: this.page.id,
          //     usernameAccount: this.linkedinUsername,
          //     passwordAccount: 'XXXX',
          //     responseBody: response.body
          //   }
          // });
        } else if (response.ok && response.body && response.body.awaitingApproval) {
          if (response.body.id) {
            this.page.id = response.body.id;
          }
          await this.fetchPages();
          this.twoFactorPopup = this.page.id;
        } else if (response.ok && response.body && response.body.captcha) {
            // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.captcha'),
              color: 'primary',
              time: 10000,
              id: 'repeat'
            }, {
              component: "Conciergerie",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          } else if (response.ok && response.body && response.body.badPassword) {
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.bad_password'),
            color: 'primary',
            time: 8000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        } else if (response.ok && response.body && response.body.invalidUser) {
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.invalid_user'),
            color: 'primary',
            time: 8000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        } else if (response.ok && response.body && response.body.csrfToken) {
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.csrf_token'),
            color: 'primary',
            time: 8000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        } else if (response.ok && response.body && response.body.notImplementedChall) {
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.not_implemented'),
            color: 'primary',
            time: 10000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        }
        else if (!response.ok) {
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: response.bodyText,
            color: 'primary',
            time: 5000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              response: response
            }
          });
        }
      });
    },

    async disconnectConciergerie(idPage) {
      // console.log(idPage);
      await this.disconnectDirectApi(idPage);
      this.getPagesEvent()
      // this.gridData = this.gridData.map(e => {
      //   if (e.pages.id === idPage) {
      //     e.pages.story_config = null;
      //     e.bots[0].page.story_config = null;
      //   }
      //   return e;
      // });
      // await this.fetchPages();
      // await this.fetchBots();
      // this.$emit('update-multipletable', this.gridData)
      // this.$forceUpdate();
    },

    async closePopup(payload) {
      if (payload && payload.story_config) {
        this.$set(this.page, 'story_config', payload.story_config);
      }
      if (payload && payload.id) {
        this.$set(this.page, 'id', payload.id);
      }
      this.twoFactorPopup = false;
      this.connectionReturn = true;
      this.$emit('closeActiveConciergerie')
      // await this.fetchPages(); 
      // this.submitAfterConnection();
    },

    getPagesEvent() {
      this.$emit('getPagesEvent')
    },

    async fetchPages() {
        return this.getPages()
                   .then(res => {
                    //  console.log(res.body)
                     const { pages } = res.body
                     // TODO remove this once it wont be used
                     localStorage.setItem('pages', JSON.stringify(pages))
                     this.pages = pages
                       .sort((page1, page2) => {
                         const [d1, d2] = [page1, page2].map(x => new Date(x.updated_at))
                         if (d1 < d2) return -1
                         if (d1 > d2) return +1
                         return 0
                       })
                   })
      },
  }
}
</script>
